<template>
  <div>
    <div class="top">
      <img class="picimg" src="@/assets/image/BIM全过程应用服务.png" />
    </div>
    <div style="display: flex; align-items: center" class="prompt">
      <img class="icon" src="@/assets/images/zhuye.png" />
      <span class="color858"
        >&nbsp;&nbsp;你现在的位置&nbsp;&nbsp;/&nbsp;&nbsp;首页&nbsp;&nbsp;/&nbsp;&nbsp;</span
      >
      <span>BIM全过程应用服务</span>
    </div>
    <div class="titleBox">
      <span class="title">BIM FULL PROCESS</span>
      <span class="title1">BIM全过程应用服务</span>
      <span class="line"></span>
    </div>
    <div class="service-main">
      <section class="pc-section">
        <h2 class="pc-h2">
          <span class="pc-h2-bar"></span>
          应用介绍
        </h2>
        <p class="pc-intro">
          BIM（建筑信息建模）技术是一种全新的建筑设计和管理工具，它可以在建筑项目的全生命周期内进行应用，包括规划、设计、施工、运营和维护等。
        </p>
        <div class="pc-step-paras">
          <p class="pc-step-line">
            <span class="pc-step-label">规划、设计：</span>BIM技术可用于各种建筑设计领域，包括建筑、结构、机电、管道等领域，通过BIM技术的3D建模、协同设计、可视化等功能，实现设计方案的可视化、交互式呈现，方便各方协同配合，减少设计失误和节约设计成本。
          </p>
          <p class="pc-step-line">
            <span class="pc-step-label">建筑施工：</span>BIM技术可用于建筑施工阶段的规划和模拟，通过模型构建、施工进度计划、施工协调等功能，实现整个项目的数字化管理、自动化协调和节约人力资源。
          </p>
          <p class="pc-step-line">
            <span class="pc-step-label">运营和维护：</span>BIM技术可用于建筑运营和维护阶段的管理和维护，通过模型管理、数据分析和维护计划等功能，实现建筑全生命周期的数字化管理，提高运营效率，降低运营成本。
          </p>
          <p class="pc-step-line">
            <span class="pc-step-label">建筑管理：</span>BIM技术可用于建筑管理阶段的跟踪和监测，通过模型管理、数据分析和维护计划等功能，实现建筑全生命周期的数字化管理，提高管理效率，降低管理成本。
          </p>
        </div>
      </section>

      <section class="pc-section">
        <h2 class="pc-h2">
          <span class="pc-h2-bar"></span>
          技术框架
        </h2>
        <div class="pc-framework-wrap">
          <img
            class="pc-framework-img"
            src="@/assets/image/技术框架.png"
            alt="BIM 技术框架示意图"
          />
        </div>
      </section>

      <section class="pc-section">
        <h2 class="pc-h2">
          <span class="pc-h2-bar"></span>
          应用阶段及内容
        </h2>
        <div class="bim-stages">
          <div class="bim-stage-row">
            <div class="bim-stage-card">
              <div class="bim-stage-card-head">规划模拟</div>
              <div class="bim-stage-card-body">
                <img
                  src="@/assets/image/规划模拟.png"
                  alt="规划模拟"
                />
              </div>
            </div>
            <div class="bim-stage-detail">
              <div class="bim-stage-title-row">
                <i class="el-icon-setting bim-stage-icon-el" aria-hidden="true"></i>
                <h3 class="bim-stage-title">规划阶段解决方案</h3>
              </div>
              <ul class="bim-stage-ul">
                <li>无人机航飞（倾斜摄影、地形测绘等）</li>
                <li>数字地形模拟</li>
                <li>规划方案可视化模拟</li>
                <li>项目拆迁管理</li>
                <li>土方测算和调运规划</li>
              </ul>
            </div>
          </div>

          <div class="bim-stage-row">
            <div class="bim-stage-card">
              <div class="bim-stage-card-head">问题报告</div>
              <div class="bim-stage-card-body">
                <img
                  src="@/assets/image/问题报告.png"
                  alt="问题报告"
                />
              </div>
            </div>
            <div class="bim-stage-detail">
              <div class="bim-stage-title-row">
                <i class="el-icon-monitor bim-stage-icon-el" aria-hidden="true"></i>
                <h3 class="bim-stage-title">设计阶段解决方案</h3>
              </div>
              <ul class="bim-stage-ul">
                <li>设计方案可视化模拟</li>
                <li>全专业模型创建（方案模型、初设模型、施工图设计模型  建筑结构、机电、钢结构、幕墙、精装等）</li>
                <li>图纸问题查找</li>
                <li>碰撞检查、净高分析</li>
                <li>专项问题分析（卷帘门、车位等）</li>
                <li>管线综合调整和出图（含留洞图）</li>
                <li>工程量计算（清单和定额工程量）</li>
                <li>设计协同（问题协调、图纸管理等）</li>
              </ul>
            </div>
          </div>

          <div class="bim-stage-row">
            <div class="bim-stage-card">
              <div class="bim-stage-card-head">施工深化</div>
              <div class="bim-stage-card-body">
                <img
                  src="@/assets/image/施工深化.png"
                  alt="施工深化"
                />
              </div>
            </div>
            <div class="bim-stage-detail">
              <div class="bim-stage-title-row">
                <i class="el-icon-s-tools bim-stage-icon-el" aria-hidden="true"></i>
                <h3 class="bim-stage-title">施工阶段解决方案</h3>
              </div>
              <ul class="bim-stage-ul">
                <li>施工图深化</li>
                <li>变更维护</li>
                <li>三维交底和现场指导</li>
                <li>BIM巡检</li>
                <li>施工进度模拟和分析</li>
                <li>工艺动画模拟</li>
                <li>施工管理信息化应用（质量、安全、机械、验收、进度、成本等）</li>
                <li>竣工模型</li>
              </ul>
            </div>
          </div>

          <div class="bim-stage-row bim-stage-row--last">
            <div class="bim-stage-card">
              <div class="bim-stage-card-head">运维平台</div>
              <div class="bim-stage-card-body">
                <img
                  src="@/assets/image/运维平台.png"
                  alt="运维平台"
                />
              </div>
            </div>
            <div class="bim-stage-detail">
              <div class="bim-stage-title-row">
                <i class="el-icon-office-building bim-stage-icon-el" aria-hidden="true"></i>
                <h3 class="bim-stage-title">运维阶段解决方案</h3>
              </div>
              <ul class="bim-stage-ul">
                <li>运维模型</li>
                <li>
                  对接运维平台及开发（设备监控、环境管理、能耗管理、人流监测、巡检管理、安防管理、物业管理等）
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Bottom />
    <Right />
  </div>
</template>

<script>
import Bottom from "./bottom.vue";
import Right from "./right.vue";

export default {
  components: {
    Bottom,
    Right,
  },
};
</script>

<style lang="scss" scoped>
$pc-orange: #f29600;
$pc-step-label: #5b9bd5;

.service-main {
  max-width: 960px;
  margin: 0 auto 80px;
  padding: 0 40px;
  line-height: 1.8;
  font-size: 16px;
  color: #333;
}

.pc-section {
  margin-top: 40px;

  &:first-of-type {
    margin-top: 20px;
  }
}

.pc-h2 {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0 0 20px;
}

.pc-h2-bar {
  width: 4px;
  height: 22px;
  background: $pc-orange;
  margin-right: 10px;
  flex-shrink: 0;
}

.pc-intro {
  text-indent: 2em;
  margin: 0 0 16px;
}

.pc-step-paras {
  margin: 0;
}

.pc-step-line {
  margin: 0 0 14px;
  text-align: justify;
}

.pc-step-label {
  color: $pc-step-label;
  font-weight: 700;
}

.pc-framework-wrap {
  width: 100%;
  margin: 0;
  border-radius: 4px;
  overflow: hidden;
  background: #f0f4f8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pc-framework-img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}

$bim-card-head: #4d4d4d;
$bim-border: #c8c8c8;

.bim-stages {
  margin-top: 4px;
}

.bim-stage-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 28px;
  padding-bottom: 28px;
  margin-bottom: 28px;
  border-bottom: 1px solid #e5e5e5;

  &--last {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
}

.bim-stage-card {
  flex: 0 1 380px;
  max-width: 100%;
  min-width: 0;
}

.bim-stage-card-head {
  background: $bim-card-head;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  padding: 10px 14px;
  letter-spacing: 0.02em;
}

.bim-stage-card-body {
  border: 1px solid $bim-border;
  border-top: none;
  background: #fff;
  line-height: 0;

  img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
    max-height: 280px;
    object-position: center;
  }
}

.bim-stage-detail {
  flex: 1 1 280px;
  min-width: 0;
  padding-top: 2px;
}

.bim-stage-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.bim-stage-icon-el {
  font-size: 22px;
  color: $pc-step-label;
  flex-shrink: 0;
}

.bim-stage-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: $pc-step-label;
}

.bim-stage-ul {
  margin: 0;
  padding-left: 1.35em;
  color: #333;

  li {
    margin-bottom: 8px;
    line-height: 1.65;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

@media (max-width: 768px) {
  .service-main {
    padding: 0 20px;
  }

  .bim-stage-row {
    flex-direction: column;
    gap: 18px;
  }

  .bim-stage-card {
    flex: none;
    width: 100%;
  }

  .bim-stage-card-body img {
    max-height: 240px;
  }
}
</style>
